<template>
  <div class="watermark-field">
    <div class="title">
      <span>水印</span>
      <i class="dot"></i>
    </div>
    <div
      class="item"
      v-for="(item, i) in items"
      :key="i"
      @click="setActive(i, item)"
    >
      <div
        class="radio"
        :class="{active: watermarkType === item.value}"
      ></div>
      <div class="item-text">{{item.text}}</div>
      <div
        style="flex-shrink: 0;margin-left: 5px;"
        v-if="item.value == 'none' || item.value == 'custom'"
      >
        <!-- <vipBadge :level="item.value === 'custom' ? 'high' : 'low'"></vipBadge> -->
        <vipBadge
          :level="'high'"
          :text="'限免'"
          :fontSize="10"
        ></vipBadge>
      </div>
      <label
        v-if="item.value == 'custom'"
        class="upload-btn"
        style="flex-shrink: 0;margin-left: 10px;"
        ref="inputLabel"
      >
        上传
        <input
          type="file"
          name
          accept="image/png, image/jpeg, image/jpg"
          ref="watermarkInput"
          @change="inputChange($event)"
        />
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import imageType from "image-type";
import vipBadge from '@/components/widgets/vipBadge.vue';

export default {
  data () {
    return {
      customWatermark: '',
      activeIndex: 0,
      items: [
        { text: '默认水印', value: 'default' },
        { text: '无水印', value: 'none' },
        { text: '自定义水印', value: 'custom' },
      ]
    }
  },
  components: {
    vipBadge
  },
  computed: {
    activeItem () {
      return this.items[this.activeIndex];
    },
    ...mapGetters({
      customWatermarkUrl: 'subtitleExport/customWatermarkUrl',
      watermarkType: 'subtitleExport/watermarkType'
    }),
    ...mapGetters([
      'UserLevel',
      'UserLevelType',
      'UserEquity',
      "isPersonVip",
      'UserMsg'
    ])
  },
  watch: {
    activeItem (val) {
      this.$store.commit('subtitleExport/setWatermarkType', val.value);
    }
  },
  methods: {
    setActive (index, item) {
      // let key = item.value;
      // const vm = this;
      // if (key === "none" && !vm.UserEquity.closeWaterMark) {
      //   let prefix = vm.isPersonVip ? vm.watermarkInfo.none.tip : "";
      //   if (
      //     (vm.UserLevelType === 0 && vm.UserLevel === 0) ||
      //     vm.UserMsg.tmpLevelType
      //   ) {
      //     vm.$modal.show("subtitleVipDialog", {
      //       msg: "升级个人VIP, 获得36次无水印权益及解锁更多会员功能。",
      //       target: "vipsolo",
      //       type: "solo",
      //       bottomLink: "/vip",
      //       bottomLinkTarget: "_blank",
      //       bottomLinkText: "视频无水印(无限次),点击了解高级会员。"
      //     });
      //   }
      //   if (vm.isPersonVip) {
      //     if (vm.UserMsg.tmpLevelType != null) {
      //       vm.$modal.show("subtitleVipDialog", {
      //         msg: "请购买资源包叠加权益或者开通企业会员无限使用。",
      //         target: "vip",
      //         type: "vip",
      //         package: "vipsolo/payment?source=1",
      //         secondaryBtnType: 'package'
      //       });
      //     } else {
      //       vm.$modal.show("subtitleVipDialog", {
      //         msg:
      //           "您的视频无水印次数已用完,请购买资源包叠加权益或者开通企业会员无限使用。",
      //         target: "vip",
      //         type: "vip",
      //         package: "vipsolo/payment?source=1",
      //         secondaryBtnType: 'package'
      //       });
      //     }
      //   }
      //   vm.UserLevelType === 1 &&
      //     vm.$modal.show("subtitleVipDialog", {
      //       msg: "开通企业会员可无限使用无水印及自定义水印。",
      //       target: "vip",
      //       type: "vip"
      //     });
      //   return;
      // }
      // else if (key === "custom" && !vm.UserEquity.waterMark) {
      //   let prefix = this.isPersonVip ? this.watermarkInfo.custom.tip : "";
      //   (vm.UserLevelType === 1 || vm.UserMsg.tmpLevelType) &&
      //     vm.$modal.show("subtitleVipDialog", {
      //       msg: "开通企业会员可无限使用无水印及自定义水印。",
      //       target: "vip",
      //       type: "vip"
      //     });
      //   // this.isPersonVip &&
      //     this.$modal.show("subtitleVipDialog", {
      //       msg: "升级企业会员，解锁自定义水印，助力品牌推广。",
      //       target: "vip",
      //       type: "vip"
      //     });
      //   return
      // }

      if (!item) {
        item = this.items[index];
      }
      if (item.value === 'custom' && !this.customWatermarkUrl) {
        this.$refs.watermarkInput[0].click();
        return;
      }
      this.activeIndex = index;
    },

    inputChange (event) {
      let file = event.target.files[0];
      this.file = event.target.files;
      // 素材上传图片
      const vm = this;
      let _this = this;
      let uploadImageData = new FormData(),
        errorData = {
          errorSize: 0,
          index: 0
        };
      this.file = event.target.files;
      if (file && file.size > 200 * 1024) {
        this.$message({
          showClose: true,
          message: "水印素材上传需限制在200KB内。",
          type: "error"
        });
        event.target.value = "";
        return;
      }
      for (let i = 0; i < this.file.length; i++) {
        let fileItem = this.file[i];
        if (!this.file[i] || !this.file[i].name) return;

        if (event.target.id === "imagePic") {
          if (!/\.(?:jpg|JPG|jpeg|JPEG|png|PNG)$/.test(this.file[i].name)) {
            event.target.value = "";
            alert("该文件格式不支持，请导入jpg、jpeg、png格式的图片");
            return;
          }
        } else {
          if (
            !/\.(?:jpg|jpeg|JPEG|JPG|png|PNG|gif|GIF|svg|SVG)$/.test(
              this.file[i].name
            )
          ) {
            event.target.value = "";
            alert("该文件格式不支持，请导入jpg、jpeg、png格式的图片");
            return;
          }
        }

        let reader = new FileReader();
        reader.readAsArrayBuffer(this.file[i]);


        reader.onload = async (e) => {
          errorData.index++;
          let u = new Uint8Array(reader.result);
          let accept = event.target.accept;
          let shouldBeGif = accept.indexOf("image/gif") > -1;
          let filenameArr = _this.file.length
            ? _this.file[i].name.split(".")
            : _this.file.name.split(".");
          let suffix = (
            "" + filenameArr[filenameArr.length - 1] || "空"
          ).toLowerCase();
          let t = imageType(u); // {ext: "png", mime: "image/png"}
          let judgeImgType = true;

          if (!t) {
            if (_this.file.length == 1) {
              alert(`您上传的不是${suffix}图，无法添加至项目。`);
              event.target.value = "";
              return;
            } else {
              judgeImgType = false;
              errorData.errorSize++;
            }
          }

          let ext = (t || {}).ext;
          if (shouldBeGif) {
            if (suffix != ext) {
              alert(`您上传的不是gif图，无法添加至项目。`);
              event.target.value = "";
              return;
            }
          }

          let formData = new FormData();
          formData.append("watermark", fileItem);
          let urlapi = "/api/upload/file";
          _this.$http({
            url: urlapi,
            method: "post",
            data: formData,
          })
            .then(resp => {
              event.target.value = '';
              _this.customWatermark = resp.data.data.filename;
              _this.$store.commit('subtitleExport/setCustomWatermark', {
                url: _this.customWatermark
              });
              _this.$store.commit('subtitleExport/setWatermarkType', 'custom');
              _this.setActive(2);
            })
            .catch(e => {
              console.warn(e);
            })
        };
      }
    },

    isShowBadge (type) {
      if (type === 'none' || type === 'custom') {
        return !this.UserEquity.closeWaterMark
      }
      if (type === 'custom') {
        return !this.UserEquity.waterMark
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.watermark-field {
  position: relative;
  display: flex;
}
.title {
  position: absolute;
  top: 50%;
  right: calc(100% + 28px);
  min-width: 100px;
  color: #474261;
  font-size: 14px;
  text-align: right;
  transform: translateY(-50%);
}
.item {
  display: flex;
  align-items: center;
  padding-left: 120px;
  vertical-align: middle;
  cursor: pointer;
  &:nth-of-type(2) {
    padding-left: 0;
  }
  & > .radio {
    display: inline-block;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border: 2px solid #5778fb;
    border-radius: 50%;
    &.active {
      background-color: #5778fb;
      box-shadow: 0 0 0 2px #fff inset;
    }
  }
  & > .item-text {
    display: inline-block;
    flex-shrink: 0;
    padding-left: 13px;
  }
}
.dot {
  position: absolute;
  top: -2px;
  left: 102%;
  width: 4px;
  height: 4px;
  background: #ff133a;
  border-radius: 50%;
}
.upload-btn {
  // position: absolute;
  // top: 50%;
  // left: calc(100% - 15px);
  // transform: translateY(-50%);
  width: 40px;
  height: 24px;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  background: #f6f6fc;
  border: 1px solid #d8d8e5;
  border-radius: 4px;
  cursor: pointer;
  & > input {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/watermarkField.vue